import React from 'react'

import Style from './Testimonial.module.css';
import Client__1 from './Images/Client_1.jpg';


const Testimonial = () => {
    return (
        <div className={Style.Testimonial__Section}>
            <div className='container'>
                <div className={Style.Testimonial__Item}>
                    <figure className={Style.Testimonial__Image}>
                        <img src={Client__1} alt='Jasmine Fleming - Freelance Writer' />
                    </figure>
                    <div className={Style.Testimonial__Content}>
                        <div className={Style.Description}>
                            <p>What keeps me glued to Payyit is recurring invoicing. Setting up and automatically sending them to recipients <strong>is a favorite feature.</strong></p>    
                        </div>
                        <div className={Style.Name}>Sam Bazargan - Achieve Applabs  </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Testimonial
